interface loaderTextOptions {
  'pl-PL': string,
  'en-US': string,
  'uk-UA': string,
}

const loaderText: loaderTextOptions = {
  'pl-PL': 'Trwa wczytywanie...',
  'en-US': 'Loading...',
  'uk-UA': 'Триває збереження...',
};

const bannerText: loaderTextOptions = {
  'pl-PL': 'e\u2060-\u2060Urząd\u00A0Skarbowy',
  'en-US': 'e\u2060-\u2060Tax\u00A0Office',
  'uk-UA': 'eлектронна податкова служба',
};

const loaderTextLanguageFallback = 'pl-PL';

export const getQueryVariable = (variableName: string): string | undefined => {
  const query = window.location.search.substring(1);
  const variables = query.split('&');
  for (const variable of variables) {
    const pair = variable.split('=');
    if (decodeURIComponent(pair[0]) === variableName) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log('Query variable %s not found', variableName);
};

export const showLoaderText = (slng: string | undefined): void => {
  const lang = slng || loaderTextLanguageFallback;
  document.getElementById('appLoaderText')!.innerText = loaderText[lang as keyof loaderTextOptions];
};
